import {useEffect, useRef, useState} from 'react';

export function useStateWithReinitialize<T>(
  initialState: T
): [T, React.Dispatch<React.SetStateAction<T>>] {
  const ref = useRef(initialState);
  const [state, setState] = useState(initialState);
  useEffect(() => {
    if (initialState !== ref.current) {
      ref.current = initialState;
      setState(initialState);
    }
  }, [initialState]);
  return [state, setState];
}
